__turbopack_context__.v({
  "container": "h6RiMW_container",
  "userDetails": "h6RiMW_userDetails",
});
